import { useQuery } from '@tanstack/react-query';

import { fetchListOneApprovalApi } from '../api';

export default function useListOneApprovalQuery(
  ticketId: string,
  options?: any
) {
  return useQuery(['list', 'approval', ticketId], fetchListOneApprovalApi, {
    enabled: !!ticketId,
    ...options,
  });
}
